import { createIcon } from '~/utils';

export const CheckIcon = createIcon({
  viewBox: '0 0 12 13',
  path: (
    <path d='M10.7653 4.14028L4.76534 10.1403C4.73051 10.1751 4.68915 10.2028 4.64363 10.2217C4.5981 10.2405 4.54931 10.2503 4.50003 10.2503C4.45074 10.2503 4.40195 10.2405 4.35642 10.2217C4.3109 10.2028 4.26954 10.1751 4.23471 10.1403L1.60971 7.51528C1.53935 7.44491 1.49982 7.34948 1.49982 7.24996C1.49982 7.15045 1.53935 7.05502 1.60971 6.98465C1.68008 6.91429 1.77551 6.87476 1.87503 6.87476C1.97454 6.87476 2.06997 6.91429 2.14034 6.98465L4.50003 9.34481L10.2347 3.60965C10.3051 3.53929 10.4005 3.49976 10.5 3.49976C10.5995 3.49976 10.695 3.53929 10.7653 3.60965C10.8357 3.68002 10.8752 3.77545 10.8752 3.87496C10.8752 3.97448 10.8357 4.06991 10.7653 4.14028Z' />
  ),
});
